/**
 * Types for the Unified Market Selector
 * Supports CEX Spot, Perpetuals (Hyperliquid), and DEX markets
 */

export enum UnifiedMarketType {
  SPOT = "SPOT", // CEX Spot markets
  PERPS = "PERPS", // Perpetuals (Hyperliquid)
  DEX = "DEX", // DEX markets
}

export interface UnifiedMarket {
  type: UnifiedMarketType;
  symbol: string; // Display symbol (e.g., "BTC/USDT", "BTC-PERP", "ETH/USDC")
  baseAsset: string;
  quoteAsset: string;

  // for Perps markets
  funding?: string;
  openInterest?: string;
  maxLeverage?: number;
  externalMarketId?: string;

  // For CEX Spot
  exchangeId?: string; // CEX exchange ID (e.g., "binance", "kucoin")
  exchangeName?: string; // Display name

  // For DEX
  dexProtocol?: string; // DEX protocol (e.g., "aerodrome-cl")
  dexName?: string; // Display name (e.g., "Aerodrome (Base)")
  chainName?: string; // Chain name (e.g., "Base", "Solana")
  dexLogo?: string; // Logo path for DEX
  pairAddress?: string; // DEX pair/pool address
  token0Address?: string; // Address of first token in pair
  token1Address?: string; // Address of second token in pair
  baseAssetName?: string; // Full name of base token (e.g., "Bitcoin", "Ethereum") - used for DEX tokens
  logo?: string; // Token logo URL (from API for DEX tokens)

  // Market data
  markPrice?: string;
  volume24h?: string;
  priceChange24h?: number;

  // UI helpers
  searchString: string; // Lowercase for search
  isDisabled?: boolean; // For non-connected CEX
  chainId?: string; // For DEX favorites/identity
  isPopular?: boolean; // Flag for highlighting trending tokens
}

export interface ExchangeFilter {
  id: string;
  name: string;
  logo?: string;
  isConnected?: boolean; // For CEX only
  chainName?: string; // For DEX only
}
